module.exports = __webpack_public_path__ + "assets/src/style/img/svg/icons/category-this-week.svg?5133ba9ccd46568396aa26c92394b874";